/**
 * Parser de User-Agent tolerante (só p/ rótulo humano de "dispositivos conectados").
 * Nunca lança; UA nulo/desconhecido → rótulo genérico.
 */
export interface ParsedUA {
  isMobile: boolean;
  browser: string;
  os: string;
  /** "Chrome · Windows" (ou "Dispositivo desconhecido"). */
  summary: string;
}

function detectOS(ua: string): string {
  if (/windows nt/i.test(ua)) return 'Windows';
  if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
  if (/android/i.test(ua)) return 'Android';
  if (/mac os x|macintosh/i.test(ua)) return 'macOS';
  if (/linux/i.test(ua)) return 'Linux';
  return 'Sistema desconhecido';
}

function detectBrowser(ua: string): string {
  // Ordem importa: Edge/Opera fingem ser Chrome; Chrome finge ser Safari.
  if (/edg(e|a|ios)?\//i.test(ua)) return 'Edge';
  if (/opr\/|opera/i.test(ua)) return 'Opera';
  if (/firefox|fxios/i.test(ua)) return 'Firefox';
  if (/chrome|crios|chromium/i.test(ua)) return 'Chrome';
  if (/safari/i.test(ua)) return 'Safari';
  return 'Navegador desconhecido';
}

export function parseUserAgent(ua: string | null): ParsedUA {
  if (!ua || !ua.trim()) {
    return { isMobile: false, browser: '', os: '', summary: 'Dispositivo desconhecido' };
  }
  const isMobile = /mobi|android|iphone|ipod|iemobile|blackberry/i.test(ua);
  const browser = detectBrowser(ua);
  const os = detectOS(ua);
  return { isMobile, browser, os, summary: `${browser} · ${os}` };
}
